import React from 'react';
interface PauseArtProps {
  rippling: boolean;
}
const PAUSE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/1f41e726-8cb7-44c8-80f1-cd37a2f4c205.jpg';
export function PauseArt({
  rippling
}: PauseArtProps) {
  return <div role="img" aria-label="Acacia shade over still water. The ground is quiet." className="relative aspect-[16/9] w-full overflow-hidden bg-[#d9c79c]" data-id="element-5" data-mp="11ssc0qci2xi1">
      <img src={PAUSE_IMAGE} alt="" width={1376} height={768} decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-6" data-mp="94o8aadhouhz" />
      {rippling && <svg viewBox="0 0 800 450" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-7" data-mp="i2qed4c2ydc4">
          <g stroke="#FFFFFF" strokeWidth="2" fill="none" opacity="0.8" data-id="element-8" data-mp="mwkrtq13dw2r">
            <ellipse className="anim-ripple" cx="420" cy="340" rx="44" ry="8" data-id="element-9" data-mp="3mjax838936sc" />
            <ellipse className="anim-ripple" style={{
          animationDelay: '1.6s'
        }} cx="420" cy="340" rx="44" ry="8" data-id="element-10" data-mp="3qjl5jmjim9ad" />
            <ellipse className="anim-ripple" style={{
          animationDelay: '3.2s'
        }} cx="420" cy="340" rx="44" ry="8" data-id="element-11" data-mp="6gl68zrcusc" />
          </g>
        </svg>}
    </div>;
}